/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ElectroDatePicker from 'forms/components/inputs/ElectroDatePicker/ElectroDatePicker';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import type Form from '../../../../../../forms/_.extend';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  actionDrawerStore: TypeActionDrawerStore,
  project: Object,
  projectDetailsStore: Object,
  form: Form,
};

@translate()
@inject('actionDrawerStore', 'projectDetailsStore')
@observer
export default class ExtendProjectMultiForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { form }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:reasons.when_extend_till')}
          >
            <div className={styles['form-group']}>
              <ElectroDatePicker field={form.$('extendProjectForm.endDate')} />
              <ElectroSelectWithOther
                field={form.$('extendProjectForm.reason')}
                otherHeading={`${t('general:reasons.provide_reason')} *`}
              />
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.extend_project')} />
      </React.Fragment>
    );
  }
}
